import React from 'react';
import ReactPlayer from 'react-player';

import './VideoPlayer.scss';

export default function VideoPlayer( {
  url, // string.
} ) {

  return(
    <div className="VideoPlayer">
      <ReactPlayer
      className="VideoPlayer__video"
      url={ url }
      width="100%"
      height="100%"
      />
    </div>
  )

}